<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addToQuote, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    #access(v-if="has_permission")
      modal-import(model="to_quote" :title="$t('front.import_modal', {model: $t('strings.to_quote')})")
      modal-to-quotes(:newRecord='newRecord', :additional='isModalAdditional' :quote="isModalQuote")
      modal-quotation(:newRecord='newRecord')
      modal-select-employee(:project_id='project_id', :employees_flag='employees_flag', :selected_employees='selected_employees')
      modal-select-contact(:project_id='project_id', :contacts_flag='contacts_flag', :selected_contacts='selected_contacts')
      .container-fluid
        vm-row.heading(vm-w="12")
          vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
            .list-title-cont
              .title-c
                h2 {{ $t('strings.to_quote') }}
                stage-indicator
              span {{ $t('strings.to_quote_description') }}
            div(style="display:none;")
              vm-button(type="default" icon="list")
              vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
            div
              vm-button(icon="plus" @click="addToQuote" v-if="projects_store_permission") {{ $t('strings.add') }}
              vm-tooltip(:text="$t('strings.options')" delay=".5s")
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                      vm-icon(icon="printer-outline")
                      slot &nbsp;{{ $t('strings.print') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteToQuotesConfirm" :disabled="!enabledDelete" v-if="!$auth.check('Customer')")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)" v-if="!$auth.check('Customer')")
                      vm-icon(icon="upload-outline")
                      slot &nbsp;{{ $t('strings.import') }}
                    //- More options
                        Agrega mas acciones para colecciones de datos
        vm-row(vm-w="12")
          vm-col.card(vm-sm=12)
            vm-table(multiple v-model="selected"  max-height="350px" :data="toQuotes")
              template(slot="header")
                .d-flex.justify-content-between
                  vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                  div
                    vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="changeOrderBy(filters)" size="small" width="200px" :serializer="item => $t('projects.'+ item)")
                    vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                      vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                        vm-button(type="default" icon="funnel-outline" size="small")

                        vm-dropdown-menu(class="filters")
                          .heading.d-flex.justify-content-between
                            h4 {{ $t('strings.filters') }}
                            vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Additional" v-model="filters.whereIn.additional")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in additional")
                          //- Add filters
                              Agrega los filtros que prefieras por ejemplo:
                              vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                              vm-select.filter(url="customers" columns="tradename,etc" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                                vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in toQuotesCatalog.customers")
                              vm-date-picker.filter(type="daterange" :label="$t('to_quotes.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")

                              NOTA: (agregar clase .filter)
                          .filter.d-flex
                            vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
              template(slot="thead")
                //- vm-th(:key="index" v-if="column !== 'id' && (docs_index_permission || column !== 'docs_date_recived')" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
                vm-th(v-if="docs_index_permission") {{ $t('projects.' + 'project_name') }}
                vm-th(v-if="docs_index_permission") {{ $t('projects.' + 'location') }}
                vm-th(v-if="docs_index_permission & $auth.user().view_roles.findIndex(e => e === 'Customer')") {{ $t('projects.' + 'customer') }}
                vm-th(v-if="docs_index_permission & $auth.user().view_roles.findIndex(e => e === 'Customer')") {{ $t('projects.' + 'contact') }}
                vm-th(v-if="docs_index_permission & $auth.user().view_roles.findIndex(e => e === 'Customer')") {{ $t('projects.' + 'phone') }}
                vm-th(v-if="docs_index_permission") {{ $t('projects.' + 'project_created_on') }}
                vm-th(v-if="docs_index_permission") {{ $t('projects.' + 'project_created_by') }}
                vm-th(v-if="docs_index_permission") {{ $t('projects.' + 'docs_date_recived') }}
                vm-th(v-if="docs_index_permission") {{ $t('projects.' + 'quotation_delivery_date') }}
                vm-th(v-if="docs_index_permission") {{ $t('projects.' + 'changes_orders') }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr]['project_name']" v-if="docs_index_permission") {{ data[indextr]['project_name'] }}
                  vm-td(:data="data[indextr]['location']" v-if="docs_index_permission") {{ data[indextr]['location'] }}
                  vm-td(:data="data[indextr]['customer']" v-if="docs_index_permission & $auth.user().view_roles.findIndex(e => e === 'Customer')") {{ data[indextr]['customer']['name'] }}
                  vm-td(:data="data[indextr]['contact']" v-if="docs_index_permission & $auth.user().view_roles.findIndex(e => e === 'Customer')") {{ data[indextr]['customer']['contact'] }}
                  vm-td(:data="data[indextr]['phone']" v-if="docs_index_permission & $auth.user().view_roles.findIndex(e => e === 'Customer')") {{ data[indextr]['customer']['phone'] }}
                  vm-td(:data="data[indextr]['project_created_on']" v-if="docs_index_permission") {{ data[indextr]['project_created_on'] }}
                  vm-td(:data="data[indextr]['project_created_by']" v-if="docs_index_permission") {{ data[indextr]['project_created']['name'] }}
                  vm-td(:data="data[indextr]['docs_date_recived']" v-if="docs_index_permission")
                    vm-date-picker(@on-change="docsRecived(data[indextr])" :value="data[indextr]['docs_date_recived']" @input="updateDate" :disabled="data[indextr]['stage'] !== 1 || !docs_update_permission")
                  vm-td(:data="data[indextr]['quotation_delivery_date']" v-if="docs_index_permission") {{ data[indextr]['quotation_delivery_date'] }}
                  vm-td(:data="data[indextr]['additional']" v-if="docs_index_permission") {{ data[indextr]['additional'] == 1 ? 'SI' : 'NO' }}

                  vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu(v-if="data[indextr]['stage'] === 1")
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteToQuoteConfirm(data[indextr])" v-if="projects_destroy_permission")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="quotation(data[indextr])" v-if="data[indextr]['docs_date_recived'] && quotations_update_permission")
                        vm-icon(icon="file-text-outline")
                        slot &nbsp;{{ $t('strings.create_quotation') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="selectEmployee(data[indextr])" v-if="canSelectEmployees(data[indextr].customer_id)")
                        vm-icon(icon="people-outline")
                        slot &nbsp;{{ $t('strings.select_employees') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="selectContact(data[indextr])" v-if="canSelectContacts(data[indextr].customer_id)")
                        vm-icon(icon="people-outline")
                        slot &nbsp;{{ $t('strings.select_contacts') }}
                      //- vm-dropdown-item.d-flex.justify-content-between(@click="selectEmployee(data[indextr])" v-if="projects_destroy_permission")
                      //-   vm-icon(icon="people-outline")
                      //-   slot &nbsp;{{ $t('strings.select_employee') }}
                      //- More actions
            vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
            transition(name="enter")
              .total-records(v-if="total>0") Total: {{ total | currency }}
    #no-access(v-else)
      access-denied
</template>

<script>
import moment from 'moment'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ToQuotes')

export default {
  name: 'ToQuotes',
  components: {
    ModalToQuotes: () => import('@/components/modals/ModalToQuotes.vue'),
    ModalImport: () => import('@/components/modals/ModalImport.vue'),
    ModalQuotation: () => import('@/components/modals/ModalQuotation.vue'),
    ModalSelectEmployee: () => import('@/components/modals/ModalSelectEmployee.vue'),
    ModalSelectContact: () => import('@/components/modals/ModalSelectContact.vue'),
    StageIndicator: () => import('@/components/aditionals/StageIndicator.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue')
  },
  data: () => ({
    currentPage: 1,
    isModalAdditional: true,
    isModalQuote: true,
    newRecord: {},
    project_id: '',
    selected: [],
    employees_flag: [],
    selected_employees: [],
    contacts_flag: [],
    selected_contacts: [],
    has_permission: true,
    docs_index_permission: true,
    docs_update_permission: true,
    projects_store_permission: true,
    projects_destroy_permission: true,
    quotations_update_permission: true,
    editDate: null,
    columns: [
      'project_name',
      'location',
      'customer',
      'contact',
      'phone',
      'project_created_on',
      'project_created_by',
      'docs_date_recived',
      'quotation_delivery_date',
      'changes_orders'
    ],
    columnsOrderBy: [
      'project_name'
    ],
    additional: [
      {
        text: 'NO',
        value: 0
      },
      {
        text: 'SI',
        value: 1
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        project_name: '',
        param: ''
      },
      whereIn: {
        additional: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    await this.loadCustomer({ url: 'customers', filter: '&user_id=' + this.$auth.user().id })
    await this.loadToQuotesCatalog()
    if (this.$route.params.customerId) {
      await this.getToQuotes(1, this.$route.params.customerId)
    } else {
      await this.getToQuotes(1)
    }
    this.checkPermission('to_quotes.index')
  },
  methods: {
    ...mapActions([
      'deleteToQuote',
      'deleteToQuotes',
      'loadToQuotes',
      'loadCustomer',
      'loadToQuotesCatalog',
      'actionToQuote',
      'setModalImportVisible',
      'setModalVisible',
      'setModalQuotationVisible',
      'setModalEmployeeVisible',
      'setModalContactVisible',
      'printReport',
      'applyFilter',
      'clearFilter',
      'editToQuote',
      'loadProject',
      'loadEmployees',
      'setDocsDateRecived'
    ]),
    changeOrderBy (data) {
      if (data.orderBy) {
        let [field, order] = data.orderBy.split(',')
        if (order === 'dsc') {
          order = 'desc'
        }
        data.orderBy = `${field},${order}`
      }
      this.applyFilter(data)
    },
    updateDate (date) {
      this.editDate = date
    },
    checkPermission (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.docs_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'docs_reciveds.index') > -1
      this.docs_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'docs_reciveds.update') > -1
      this.projects_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'projects.store') > -1
      this.projects_destroy_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'projects.destroy') > -1
      this.quotations_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'quotations.update') > -1
    },
    canSelectEmployees (id) {
      if (this.customer) {
        return this.customer.id === id
      }
      return true
    },
    canSelectContacts (id) {
      if (this.customer) {
        return this.customer.id === id
      }
      return true
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.toQuotes.findIndex(u => u.id === this.selected[0].id)
      this.editToQuote(this.selected[0], idx)
    },
    addToQuote () {
      this.isModalAdditional = false
      this.isModalQuote = false
      this.newRecord = {
        project_created_on: moment().format('YYYY-MM-DD'),
        quotation_delivery_date: moment().add(1, 'week').format('YYYY-MM-DD')
      }
      this.setModalVisible(true)
    },
    quotation (toQuote) {
      this.newRecord = { ...toQuote }
      this.newRecord.quotation_start_date = moment().format('YYYY-MM-DD')
      this.newRecord.quotation_delivery_date = toQuote.quotation_delivery_date || moment().add(1, 'week').format('YYYY-MM-DD')
      this.setModalQuotationVisible(true)
    },
    async selectEmployee (toQuote) {
      this.project_id = toQuote.id
      this.employees_flag = []
      this.selected_employees = []
      let set1 = []
      await this.loadEmployees({ employer: toQuote.customer_id }).then(() => {
        if (this.employees.length > 0) {
          set1 = new Set(this.employees.map(e => e.id))
          this.employees_flag = toQuote.employees.map(e => !!set1.has(e.id))
          this.selected_employees = toQuote.employees.map(e => e.id)
          this.setModalEmployeeVisible(true)
        } else {
          this.$vm.dialog({
            color: 'primary',
            title: this.$t('projects.employee'),
            text: 'No employees found'
          })
        }
      })
    },
    async selectContact (toQuote) {
      this.project_id = toQuote.id
      this.contacts_flag = []
      this.selected_contacts = []
      let set1 = []
      await this.loadEmployees({ employer: toQuote.customer_id })
      setTimeout(() => {
        if (this.employees.length) {
          set1 = new Set(this.employees.map(e => e.id))
          this.contacts_flag = toQuote.contacts.map(e => !!set1.has(e.id))
          this.selected_contacts = toQuote.contacts.map(e => e.id)
          this.setModalContactVisible(true)
        } else {
          this.$vm.dialog({
            color: 'primary',
            title: this.$t('projects.contact'),
            text: 'No employees found'
          })
        }
      }, 1000)
    },
    async deleteToQuoteConfirm (toQuote) {
      let t = this
      this.auxDeleteToQuote = () => {
        t.deleteToQuote(toQuote).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.to_quote'), attribute: this.$t(toQuote.id) }),
        accept: this.auxDeleteToQuote
      })
    },
    async deleteToQuotesConfirm () {
      let t = this
      let toQuotesMany = parseDeleteMany(this.selected, 'id')
      this.auxDeleteToQuote = () => {
        t.deleteToQuotes(toQuotesMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.to_quote'), attribute: toQuotesMany.values }),
        accept: this.auxDeleteToQuote
      })
    },
    async setActionToQuote (record, action) {
      record.id && this.actionToQuote({ id: record.id, action })
    },
    async getToQuotes (page, customerId) {
      let t = this
      this.loadToQuotes({ page: page, customer: customerId }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let toQuote = this.toQuotes.filter(toQuote => toQuote.id === parseInt(index))[0]
      toQuote && this.editToQuote(toQuote, index)
    },
    // autoCompleteFunc (value, url) {
    //   this.loadCatalog({ filter: value, url: url })
    // },
    async docsRecived (project) {
      await this.setDocsDateRecived({ payload: project, date: this.editDate })
      this.editDate = null
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  },
  computed: {
    ...mapGetters([
      'toQuotes',
      'project',
      'pagination',
      'filterParams',
      'customer',
      'employees'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('toQuotes.' + column)}` : `${str} ${t.$t('toQuotes.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.to_quote'), columns: concatColumns, column: this.$t('projects.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getToQuotes(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getToQuotes(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.list-title-cont {
  display: flex;
  flex-direction: column;
  .title-c {
    display: flex;
    align-items: center;
  }
}
</style>
